import React from "react"
import _ from "lodash"

type IAtRest = {
  rowData: {},
  namedItems: {}
}

const ObjectsAtRest = (props: IAtRest) => {
  const type = _.get(props, "rowData.objects.type")
  const objects = type === "property" ? _.get(props, "namedItems.properties") : _.get(props, "namedItems.portfolios")
  const selectedObjects = _.get(props, "rowData.objects.ids")

  let prefix = type === "property" ? "Property Access:" : "Portfolio Access:"
  if(!selectedObjects.length) {
    return <span></span>
  } else if(selectedObjects.length === 1) {
    let code = ""
    if(type === "property") {
      prefix = "Property:"
      code = _.get(_.find(objects, (o) => o.propertyid === selectedObjects[0]), "code")
    } else {
      prefix = "Portfolio:"
      code = _.get(_.find(objects, (o) => o.portfolioid === selectedObjects[0]), "code")
    }

    return <span>{`${prefix} ${code}`}</span>
  } else return <span>{`${prefix} Detailed`}</span>
}

export default ObjectsAtRest
